import { React, useState, useEffect } from "react";
import store from '../../../../store'
import {Link} from "react-router-dom";
import classes from './ProjectNav.module.scss'

//MUI Imports
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {
    useLocation
} from "react-router-dom";

function ProjectNav({ project }) {

    // let activeClassName = "chosen"
    
    const [currentTab, setCurrentTab] = useState(0);
    let currentPath = useLocation();

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    function handleUrlSwitch(){
        
        let pathParts = currentPath.pathname.split("/");
        let currentPageIndex = pathParts.indexOf("project")+2
        let currentPageSlug = pathParts[currentPageIndex];
        store.getState().projectNav.forEach((link, index) => {
            if(currentPageSlug === link.slug){
                setCurrentTab(index)
            }
        });

    }

    useEffect(() => {   
        handleUrlSwitch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPath])

    useEffect(() => {

        handleUrlSwitch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <Box className={`content_wrapper__inner`}>
        <Box className={`${classes.ProjectNav} content_header`}> 
            <Tabs
                value={currentTab}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="basic tabs example"
                variant="scrollable"
                scrollButtons="auto"
            > 

                {(
                    store.getState().projectNav.map((link, index) => {

                        //TO-DO, we need to check the path name with the item in the loop
                        //If we have a match,
                        //We need to set the default tab selection to the index of the item.

                        //If link.slug exists in the currentpath.pathname
                        //setValue(index)
                        
                        return(
                            <Tab 
                                key={index}
                                className={`${classes.ProjectNav__tab}`}
                                value={index} 
                                label={link.title}
                                component={Link} 
                                
                                // indicatorColor="primary"
                                to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${link.slug}`}
                                sx={[
                                    {
                                        '&:hover': {
                                        color: '#868D96',
                                        },
                                    }
                                ]}
                            />     
                        )
                    })
                )}
            </Tabs>
        </Box>
        </Box>
    );
}
export default ProjectNav